import { styled, Typography } from '@mui/material';

export const BoldText = styled(Typography)`
  font-weight: bold;
`;
